import {MemberDataForList, MembersListComponentProps} from "../../models/members/member";
import {useSearchParams} from "react-router-dom";
import {UrlService} from "../../services/url";
import {useEffect, useState} from "react";
import {PaginatedResponse} from "../../models/paginated-response/paginated-response";
import {setTitle} from "../../helpers/helper";
import {FilterTable} from "../filter-table/filter-table";
import {Filter} from "../../models/filter-table/filter-table";
import {memberTableColumns} from "../../models/members/members-table-columns";

const filterFields:Filter[] = [
    {
        type: "input",
        name: "Name",
        placeholder: "Please fill Name",
        fieldKey: "name",
        selectValues: null,
        operands: [
            {name: "Like", value: "like"},
            {name: "=", value: "equal"},
            {name: "!=", value: "not-equal"},
        ]
    },
    {
        type: "input",
        name: "Last Name",
        placeholder: "Please fill Last Name",
        fieldKey: "lastName",
        selectValues: null,
        operands: [
            {name: "Like", value: "like"},
            {name: "=", value: "equal"},
            {name: "!=", value: "not-equal"},
        ]
    },
    {
        type: "input",
        name: "Street",
        placeholder: "Please fill street name",
        fieldKey: "street",
        selectValues: null,
        operands: [
            {name: "Like", value: "like"},
            {name: "=", value: "equal"},
            {name: "!=", value: "not-equal"},
        ]
    },
    {
        type: "input",
        name: "House number",
        placeholder: "Please fill house number",
        fieldKey: "houseNumber",
        selectValues: null,
        operands: []
    },
    {
        type: "input",
        name: "Kadaster number",
        placeholder: "Please fill kadaster number",
        fieldKey: "kadasterNumber",
        selectValues: null,
        operands: [
            {name: "Like", value: "like"},
            {name: "=", value: "equal"},
            {name: "!=", value: "not-equal"},
        ]
    },
]

export const MembersList = (props: MembersListComponentProps)  => {

    const [searchParams] = useSearchParams();

    const p = (searchParams.get("page") !== null ? parseInt(searchParams.get("page") as string) : 1);
    const op = (searchParams.get("onPage") !== null ? parseInt(searchParams.get("onPage") as string) : 10);
    const url = new UrlService();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(true);
    const [tableData, setTableData] = useState<PaginatedResponse<MemberDataForList>|null>(null);
    const [page, setPage] = useState<number>(p);
    const [viewOnPage, setViewOnPage] = useState<number>(10);
    const [filter, setFilter] = useState<string>((searchParams.get("filter") !== null ? searchParams.get("filter") as string : ""));

    useEffect(() => {
        getMembers();
    },[viewOnPage,page,filter]);

    useEffect(() => {
        if (p !== page) {
            setPage(p)
        }
        if (op !== viewOnPage) {
            setViewOnPage(op)
        }
    }, [p, op]);

    const updateFilter = (filter: string) => {
        console.log("Updated filter", filter)
        setFilter(filter);
        setPage(1);
    }

    const changeViewOnPage = (e: React.FormEvent<HTMLSelectElement>) => {
        let rowsCount:number = parseInt(e.currentTarget.value);
        url.updateSearchParams([["page", page+""],["onPage", rowsCount+""]])
        setViewOnPage(rowsCount)
    }

    const changePage = (e:any) => {
        let page:number = parseInt(e.currentTarget.getAttribute("custom-attr"));
        url.updateSearchParams([["page", page+""],["onPage", viewOnPage+""]])
        setPage(page);
    }

    const getMembers = async () => {

        setError(false);
        setLoading(true);

        console.log("Filter", filter)

        try {
            const response = await fetch("/api/v1/private/owners/members/paginated?page="+page+"&onPage="+viewOnPage+(filter !== "" ? "&filter="+filter : ""));
            console.log(response.url)
            if (!response.ok) {
                setError(true);
                return;
            }

            const responseData = await response.json();
            console.log(responseData);
            setTableData(responseData);
            setLoading(false);
            setError(false);
            setTitle("Members list")

        } catch (e) {
            console.log(e);
        }
    }

    return (
        <>
            <h2>Members</h2>
            <FilterTable loading={loading} error={error} filters={filterFields} data={tableData} columns={memberTableColumns} setPage={changePage} setViewOnPage={changeViewOnPage} recallData={(filter: string) => {updateFilter(filter)}}/>
        </>
        // <></>
    );

}
